import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { deleteRole } from "../../api/apiRoles";
import parseError from "../../utils/parseError";

export const useDeleteRole = () => {
    const queryClient = useQueryClient();
    const { mutate: deleteRoleMutate, isPending: isDeleting } = useMutation({
        mutationFn: deleteRole,
        onSuccess: (res) => {
            toast.success(res.message || "Role deleted");
            queryClient.invalidateQueries(["roles"]);
        },
        onError: (e) => toast.error(parseError(e) || "Failed to delete role"),
    });
    return { deleteRoleMutate, isDeleting };
};
